/**
 * @file Album Folder Purchase Success - Media button component.
 */

import React from 'react';
import PropTypes from 'prop-types';

import Button from '../../global/Button';

const propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  icon: PropTypes.node,
  to: PropTypes.string.isRequired,
};

const AlbumFolderPurchaseSuccessMediaButton = ({
  title,
  subtitle,
  icon,
  to,
}) => {
  return (
    <Button
      to={to}
      btnStyle="reset"
      className="album-purchase-success-media-button"
      target="_blank"
    >
      {icon}
      <div className="d-flex flex-column">
        <div className="text-xs text-faded">{subtitle}</div>
        <div className="text-dark">{title}</div>
      </div>
    </Button>
  );
};

AlbumFolderPurchaseSuccessMediaButton.propTypes = propTypes;

export default AlbumFolderPurchaseSuccessMediaButton;
